import React, { useEffect } from 'react'
import { ReactComponent as MinusSVG } from './svg/minus.svg'
import { ReactComponent as PlusSVG } from './svg/plus.svg'
import { Section, StakeSection } from './AutoFormStyled'
import Button from 'components/button/Button'
import Input from 'components/input/Input'
import useStakeOperations from 'functions/stakeOperations/useStakeOperations'
import SFXS from '../../assets/audios/audios'
import Currencies from 'functions/currency/getCurrencySymbol'

export default function StakeOperations({
  stake,
  setnumber,
  audio,
  handleNotification,
  gameInfo,
  colors,
}: any) {
  const { minBet, maxBet, currency, precision } = gameInfo
  const [useStake, makeMathOperation, , inputStake, setinputStake]: any =
    useStakeOperations(
      stake,
      minBet,
      maxBet,
      precision,
      audio,
      handleNotification,
      currency,
    )

  useEffect(() => {
    setnumber((+useStake).toFixed(precision))
  }, [useStake])

  return (
    <Section>
      <Button
        audio={audio}
        func={(e?: boolean) => makeMathOperation(e ? 'minus' : e)}
        longPressEnabled
        SFX={SFXS.divideSFX}
        borderColor={colors.secondary}
        background={colors.secondaryDark}
        textColor={colors.tertiary}
      >
        <MinusSVG />
      </Button>
      <StakeSection>
        <Input
          number={inputStake}
          setnumber={setnumber}
          setinputStake={setinputStake}
          toFix={precision}
          type='numbersAndDot'
          min={minBet}
          max={maxBet}
          height='24px'
          size='10px'
          textcenter='center'
          handleNotification={handleNotification}
          currency={currency}
        />
        {Currencies[currency]}
      </StakeSection>
      <Button
        audio={audio}
        func={(e?: boolean) => makeMathOperation(e ? 'plus' : e)}
        longPressEnabled
        borderColor={colors.secondary}
        background={colors.secondaryDark}
        textColor={colors.tertiary}
        SFX={SFXS.multiplySFX}
      >
        <PlusSVG />
      </Button>
    </Section>
  )
}
